/* this file is transformed by vux-loader */
/* eslint-disable */
import http from '../axios';
import apiUrl from '../apiUrl';

// 伪登录
export var apifakelogin = function apifakelogin() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.fakeLogin,
    method: 'get',
    params: query
  });
};

// 获取用户信息
export var apisession = function apisession() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.session,
    method: 'get',
    params: query
  });
};

// 获取企业信息
export var apienterprise = function apienterprise() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.enterprise,
    method: 'get',
    params: query
  });
};

// 登录
export var apilogin = function apilogin() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: apiUrl.login,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 忘记密码
export var apiforgetpwd = function apiforgetpwd() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'put';
  return http.request({
    url: apiUrl.forgetPwd,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 轮播图
export var apibannerlist = function apibannerlist() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.bannerList,
    method: 'get',
    params: query
  });
};

// 推荐服务
export var apiservicerecommendlist = function apiservicerecommendlist() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.serviceRecommendList,
    method: 'get',
    params: query
  });
};

// 服务类别列表
export var apiservicetypelist = function apiservicetypelist() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.serviceTypeList,
    method: 'get',
    params: query
  });
};

// 服务列表
export var apiservicelist = function apiservicelist() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.serviceList,
    method: 'get',
    params: query
  });
};

// 服务详情
export var apiservicedetail = function apiservicedetail() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.serviceDetail,
    method: 'get',
    params: query
  });
};

// 验证码
export var apismsvalid = function apismsvalid() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';
  return http.request({
    url: apiUrl.smsvalid,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 预约单基本信息：默认地址、模板信息等
export var apiorderbashinfo = function apiorderbashinfo() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: apiUrl.orderBashInfo,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 预约工单
export var apiappointorder = function apiappointorder() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';
  return http.request({
    url: apiUrl.appointOrder,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 公告列表
export var apinoticelist = function apinoticelist() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.noticeList,
    method: 'get',
    params: query
  });
};

// 公告详情
export var apinoticedetail = function apinoticedetail() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.noticeDetail,
    method: 'get',
    params: query
  });
};

// 邀请
export var apiinvite = function apiinvite() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: apiUrl.invite,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 新版门户
export function getNewHome(data) {
  return http.request({
    url: apiUrl.newHome,
    method: 'get',
    params: data
  });
}

// ——————————————————————————————————————————————————————————
// 废弃接口
export var apiuser = function apiuser() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: apiUrl.user,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apiwxconfig = function apiwxconfig() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.wxconfig,
    method: 'post',
    data: query
  });
};
export var apiwxImageDownload = function apiwxImageDownload() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';
  return http.request({
    url: apiUrl.wxImageDownload,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apiuserInfo = function apiuserInfo() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.userInfo,
    method: 'get',
    params: query
  });
};
export var apisystemsettingByCode = function apisystemsettingByCode() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.systemsettingByCode,
    method: 'get',
    params: query
  });
};
export var apisystemsettingloginByCode = function apisystemsettingloginByCode() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.systemsettingloginByCode,
    method: 'get',
    params: query
  });
};
export function getWorkerList(data) {
  return http.request({
    url: '/user/roleUserList',
    method: 'get',
    params: data
  });
}
// 获取全部人员列表
export function getAllUserList(data) {
  return http.request({
    url: '/v2/user/list',
    method: 'get',
    params: data
  });
}
export function getEnterprises(data) {
  return http.request({
    url: '/systemsetting/getByCodes',
    method: 'get',
    params: data
  });
}

// 获取分类列表
export function getCategoryList(data) {
  return http.request({
    url: apiUrl.categoryList,
    method: 'get',
    params: data
  });
}
// 获取分类列表子类
export function getSubLevelCategoryList(data) {
  return http.request({
    url: apiUrl.subclass,
    method: 'get',
    params: data
  });
}

// 商品列表
export function getProductList(data) {
  return http.request({
    url: apiUrl.productList,
    method: 'get',
    params: data
  });
}
// 加入购物车
export var addshoppingCart = function addshoppingCart() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';
  return http.request({
    url: apiUrl.addshoppingCart,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 商品详情
export function getproductDetails(data) {
  return http.request({
    url: apiUrl.productDetails,
    method: 'get',
    params: data
  });
}
// 获取购物车数据
export function getshoppingCartList(data) {
  return http.request({
    url: apiUrl.shoppingCartList,
    method: 'get',
    params: data
  });
}
// 获取订单列表
export function getOrderList(data) {
  return http.request({
    url: apiUrl.orderList,
    method: 'get',
    params: data
  });
}

// 修改购物车商品信息
export var updateCar = function updateCar() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';
  return http.request({
    url: apiUrl.updateCar,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
// 确定订单信息
export var postDetermineOrder = function postDetermineOrder() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';
  return http.request({
    url: apiUrl.determineOrder,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 获取联系人
export function getContacts(data) {
  return http.request({
    url: apiUrl.getContact,
    method: 'get',
    params: data
  });
}

// 线下转账
export var postOffline = function postOffline() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';
  return http.request({
    url: apiUrl.Offline,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 获取收款账号
export function getreceiptAccount(data) {
  return http.request({
    url: apiUrl.receiptAccount,
    method: 'get',
    params: data
  });
}

// 获取订单详情
export function getorderDetails(data) {
  return http.request({
    url: apiUrl.orderDetails,
    method: 'get',
    params: data
  });
}
// 获取订单商品详情
export function getorderProductDetails(data) {
  return http.request({
    url: apiUrl.orderProductDetails,
    method: 'get',
    params: data
  });
}
// 取消订单
export var cancelOrders = function cancelOrders() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';
  return http.request({
    url: apiUrl.cancelOrder,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 确认收货
export var confirmTheReceiptOfGoods = function confirmTheReceiptOfGoods() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';
  return http.request({
    url: apiUrl.confirmTheReceiptOfGoods,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 获取订单商品详情
export function getTransferInformation(data) {
  return http.request({
    url: apiUrl.getTransferInformation,
    method: 'get',
    params: data
  });
}

// 删除订单
export var deleOrder = function deleOrder() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'delete';
  return http.request({
    url: apiUrl.deleOrder,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
// 删除购物车
export function delShowCar(data) {
  return http.request({
    url: apiUrl.delShowCar,
    method: 'get',
    params: data
  });
}

// 服务团队列表
export function getServiceGroupList(data) {
  return http.request({
    url: '/servicegroup/list',
    method: 'get',
    params: data
  });
}
// 产品列表
export function getProductProductList(data) {
  return http.request({
    url: '/product/productList',
    method: 'get',
    params: data
  });
}
// 产品类别列表
export function getTypeList(data) {
  return http.request({
    url: '/product/typeList',
    method: 'get',
    params: data
  });
}
// 产品类别列表
export function getProductParentList(data) {
  return http.request({
    url: '/product/type/father',
    method: 'get',
    params: data
  });
}
// 寄修申请
export function sendrevisedordersave(data) {
  return http.request({
    url: '/send/revised/order/save',
    method: 'post',
    data: data
  });
}

// 寄修列表
export function sendrevisedorderlist(data) {
  return http.request({
    url: '/send/revised/order/list',
    method: 'get',
    params: data
  });
}
// 寄修详情
export function sendrevisedorderdetail(data) {
  return http.request({
    url: '/send/revised/order/detail',
    method: 'get',
    params: data
  });
}
// 寄修填写寄件信息
export function sendrevisedorderwriteExpress(data) {
  return http.request({
    url: '/send/revised/order/writeExpress',
    method: 'post',
    data: data
  });
}
// 物流公司
export function dictList(data) {
  return http.request({
    url: '/dict/list',
    method: 'get',
    params: data
  });
}
export function getSendRevisedOrderSendBaseInfo(data) {
  return http.request({
    url: '/send/revised/order/sendBaseInfo',
    method: 'get',
    params: data
  });
}
export function postCustomerProductFFindCustomerProduction(data) {
  return http.request({
    url: '/customer/product/findCustomerProduction',
    method: 'post',
    data: data
  });
}
export function getSystemSettingList(data) {
  return http.request({
    url: '/systemsetting/list',
    method: 'get',
    params: data
  });
}
export function getSystemSettingGetSettingUrlList(data) {
  return http.request({
    url: '/systemsetting/getSettingUrlList',
    method: 'get',
    params: data
  });
}
export function getShopOrderPaymentInfo(data) {
  return http.request({
    url: '/shop/order/paymentInfo',
    method: 'get',
    params: data
  });
}
export function getOnlinePaymentAccountList(data) {
  return http.request({
    url: '/online/payment/account/list',
    method: 'get',
    params: data
  });
}
export function getReceiveList(data) {
  return http.request({
    url: '/receive/list',
    method: 'get',
    params: data
  });
}
export function getObjPropFind(data) {
  return http.request({
    url: '/obj/prop/find',
    method: 'get',
    params: data
  });
}
/**
 * @params {string} system_type -
 * @description 获取系统日志功能配置数量
 */
export function getShopPaymentModeList(data) {
  return http.request({
    url: '/shop/payment/mode/list',
    method: 'get',
    params: data
  });
}
/**
 * @params {string} system_type -
 * @description 获取系统日志功能配置数量
 */
export function getCustomerProductList(data) {
  return http.request({
    url: '/customer/product/list',
    method: 'get',
    params: data
  });
}
export function postUploadSave(data) {
  return http.post('/upload/save', data, {
    headers: {
      _noCancel: true
    }
  });
}
export function getUploadGetFileSize(data) {
  return http.get('/upload/getFileSize', {
    params: data
  });
}